import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductListService {

  /** 
   * PRODUCT LIST LEFT MENU RESPONSIVE
   * product-list left menu computer view bing nad small.
   * PRODUCT LIST left MENU COMPUTER VIEW NAV SCROLL.
  */
  productListFilterArea = new BehaviorSubject<boolean>(false);
  productListComputerArea = new BehaviorSubject<boolean>(false);
  headerProductCategoryBarShow = new BehaviorSubject<boolean>(false);

  // FILTER AREA AND COMPUTER AREA SHOW 
  filterAreaShown: boolean = false;
  computerAreaShown: boolean = false;

  constructor() { }

  /** 
   * PRODUCT LIST LEFT MENU RESPONSIVE
   * onFilterAreaShown()
   * onProductCategory()
  */
  onFilterAreaShown() {
    this.filterAreaShown = !this.filterAreaShown;
    this.productListFilterArea.next(this.filterAreaShown);
  }

  onProductCategory() {
    this.computerAreaShown = !this.computerAreaShown;
    this.productListComputerArea.next(this.computerAreaShown);
  }

}
